import { createServiceClient } from "shared/welda/services/axiosClient";

const api = createServiceClient("/users");

const getMe = async () => await api.get("/get-me");

const getUserEmailExists = async (email) =>
  await api.get(`/user-email-exists/${email}`);

const usersService = {
  getUserEmailExists,
  getMe,
};

export default usersService;
